// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as Js_promise from "../../../../../../../node_modules/rescript/lib/es6/js_promise.js";
import * as ApiUtils$PorterinFusionkitNetworkUtils from "../../../../../../../node_modules/@porterin/fusionkit-network-utils/src/ApiUtils.mjs";
import * as OrderHistoryRepoConfig$PorterinFeature from "./OrderHistoryRepoConfig.mjs";
import * as OrderHistoryContentDummyResponse$PorterinFeature from "./dummy-responses/OrderHistoryContentDummyResponse.mjs";

function orderHistoryContent(_locale) {
  return Js_promise.then_((function (result) {
                return ApiUtils$PorterinFusionkitNetworkUtils.resolveRepoResponse(function (param) {
                            return Curry._1(OrderHistoryRepoConfig$PorterinFeature.OrderHistoryContentResponseConverter.execute, result);
                          });
              }), new Promise((function (resolve, param) {
                    resolve({
                          TAG: /* Success */0,
                          _0: OrderHistoryContentDummyResponse$PorterinFeature.dummyResponse
                        });
                  })));
}

export {
  orderHistoryContent ,
}
/* OrderHistoryRepoConfig-PorterinFeature Not a pure module */
